import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    issueCost: {
        id: 'card.issue_cost',
        defaultMessage: 'Issue cost',
    },
    monthFee: {
        id: 'card.month_fee',
        defaultMessage: 'Monthly fee',
    },
    topUpFee: {
        id: 'card.top_up_fee',
        defaultMessage: 'Top up fee',
    },
    min: {
        id: 'card.min',
        defaultMessage: 'min',
    },
    max: {
        id: 'card.max',
        defaultMessage: 'max',
    },
})
